import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Button, Snackbar, Box } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../../api/config/apiConfig";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Input from "../../../atoms/Input";
import removeImg from "../../../../imgs/remove.png";
import { useParams } from "react-router-dom";

import { useLocation } from "react-router-dom";
import PrintComponent from "../../PrintComponent";
import ItemConditionDownload from "./download";
import moment from "moment";
import MySignatureCanvas from "../../../molecules/signature_canvas";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import DescriptionIcon from "@mui/icons-material/Description";
import NoteAltIcon from "@mui/icons-material/NoteAlt";

const ItemConditionReportClientSide = () => {
  const [surveyData, setSurveyData] = useState(null);
  const [formContent, setFormContent] = useState({});

  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const updateContent = (content, mediaKys) => {
    setIsLoading(true);
    const body = {
      formContentId: formContentId,
      content: content,
      mediaKeys: mediaKys,
      removedMediaKeys: [],
    };
    updateFormContentPreview(
      surveyId,
      formId,
      email,
      token,
      body,
      formContentId
    )
      .then((res) => {
        if (email == formContent?.clientEmail)
          setSnackbarMessage("Signature has been added successfully!");
        else
          setSnackbarMessage(
            "Items Condition Report has been updated successfully!"
          );

        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  const [isValid, setIsValid] = useState(false);

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        setIsLoading(false);
      })
      .catch((error) => {
        setIsValid(false);
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);


  const [mediaKeysToSend, setMediaKeysToSend] = useState();

  const [isSignCanvas, setSignCanvas] = useState(false);

  //
  const uploadFile = async (file) => {
    const fd = new FormData();
    fd.append("image", file);

    imageUploadClientPreview(fd, surveyId, formId, email, token)
      .then((res) => {
        let values = { ...formContent };
        values.clientSign = res?.data?.data?.key;
        setFormContent(values);

        let md = [];
        md.push(res?.data?.data?.key);
        // setMediaKeysToSend(md);

        setTimeout(() => {
          updateContent(values, md);
        }, 1500);
        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        setIsValid(false);

        setIsLoading(false);
      });

  };

  const handleAddNewDataRows = () => {
    const values = { ...formContent };
    const valuesRows = [...formContent?.dataRows];
    valuesRows.push({
      no: "",
      description: "",
      condition: "",
      disclamer: "",
    });
    values.dataRows = valuesRows;

    setFormContent(values);
  };

  const handleRemoveDataRows = (ind) => {
    const values = { ...formContent };
    const valuesRows = [...formContent?.dataRows];
    valuesRows.splice(ind, 1);
    values.dataRows = valuesRows;

    setFormContent(values);
  };



  return (
    <>
      {isValid ? (
        <PremiumPublicLayout
            title="Item Condition Report at Origin"
            hideBackButton={true}
            actions={
                <div className="d-flex gap-3">
                    {!isEdit && email != formContent?.clientEmail && (
                        <Button
                            variant="contained"
                            onClick={() => {
                                setIsEdit(true);
                            }}
                            disabled={isLoading}
                             sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 24px",
                                fontWeight: 700,
                                backgroundColor: "var(--primary-color)",
                                boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                                '&:hover': { backgroundColor: 'var(--primary-hover)' }
                            }}
                            startIcon={<NoteAltIcon />}
                        >
                            Edit
                        </Button>
                    )}

                    {email == formContent?.clientEmail &&
                        formContent?.clientSign?.trim()?.length == 0 && (
                        <Button
                            variant="contained"
                            onClick={() => setSignCanvas(true)}
                            sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 24px",
                                fontWeight: 700,
                                backgroundColor: "var(--primary-color)",
                                boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                                '&:hover': { backgroundColor: 'var(--primary-hover)' }
                            }}
                        >
                            Upload Sign
                        </Button>
                    )}

                    {isEdit && (
                         <Button
                            variant="outlined"
                             color="error"
                            onClick={() => {
                                getContent();
                                setIsEdit(false);
                            }}
                            disabled={isLoading}
                             sx={{ textTransform: "none", borderRadius: "var(--radius-md)", fontWeight: 700, padding: "10px 24px", border: "1px solid" }}
                        >
                            Cancel
                        </Button>
                    )}

                    {isEdit && (
                         <Button
                            variant="contained"
                            onClick={() => {
                                updateContent(formContent, []);
                            }}
                            disabled={isLoading}
                             sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 32px",
                                fontWeight: 700,
                                backgroundColor: "var(--primary-color)",
                                boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
                                '&:hover': { backgroundColor: 'var(--primary-hover)' }
                            }}
                        >
                            Save
                        </Button>
                    )}

                    {!isEdit && (
                         <Button
                            variant="contained"
                            onClick={() => {
                                if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                      setIsLoading(true);
                                var tempTitle = document.title;
                                document.title = `Item-Condition-Report-at-Origin-${formContent?.clientName || 'Document'}-${moment().format("DD.MM.YYYY")}`;

                                // Standardized delay for print and title restoration
                                setTimeout(() => {
                                    window.print();
                                    setTimeout(() => {
                                        document.title = tempTitle;
                                        setIsLoading(false);
                                    }, 2000);
                                }, 500);
                            }}
                            disabled={isLoading}
                             sx={{ 
                                textTransform: "none", 
                                borderRadius: "var(--radius-md)", 
                                padding: "10px 24px",
                                fontWeight: 700,
                                backgroundColor: "var(--text-main)",
                                boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                                '&:hover': { backgroundColor: '#000' }
                            }}
                            startIcon={<DescriptionIcon />}
                        >
                            Save as PDF
                        </Button>
                    )}
                </div>
            }
        >
             <SectionHeader title="Items List" icon={<DescriptionIcon />} />
             <PremiumCard sx={{ marginBottom: "32px", overflow: "hidden" }}>
                  <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e0e0e0', borderRadius: '8px' }}>
                    <Table>
                        {/* Table Header */}
                        <TableHead sx={{ backgroundColor: '#f8fafc' }}>
                        <TableRow>
                            <TableCell className="table-head min-w-100 fw-bold">
                            Item No.
                            </TableCell>
                            <TableCell className="table-head min-w-400 fw-bold">
                            Item Description
                            </TableCell>
                            <TableCell className="table-head min-w-100 fw-bold">
                            Present Condition
                            </TableCell>
                            <TableCell className="table-head min-w-150 fw-bold">
                            Disclaimer Box
                            </TableCell>
                            {isEdit && (
                            <TableCell className="table-head min-w-25"></TableCell>
                            )}
                        </TableRow>
                        </TableHead>
                        <TableBody>
                        {formContent?.dataRows?.length > 0 ? (
                            <>
                            {formContent?.dataRows.map((row, index) => (
                                <TableRow key={index} hover>
                                <TableCell> {index + 1}</TableCell>
                                <TableCell>
                                    {isEdit ? (
                                    <>
                                        <Input
                                        id="condition"
                                        label="Present Condition..."
                                        type="text"
                                        style="full-border-field"
                                        value={row?.description}
                                        onChange={(e) => {
                                            const values = { ...formContent };
                                            const valuesRows = [
                                            ...formContent?.dataRows,
                                            ];
                                            valuesRows[index].description =
                                            e.target.value;
                                            values.dataRows = valuesRows;
                                            setFormContent(values);
                                        }}
                                        inline={{ width: "-webkit-fill-available" }}
                                        />
                                    </>
                                    ) : row?.description ? (
                                    row?.description
                                    ) : (
                                    "-"
                                    )}
                                </TableCell>
                                <TableCell>
                                    {isEdit ? (
                                    <Input
                                        id="condition"
                                        label="Present Condition..."
                                        type="text"
                                        style="full-border-field"
                                        value={row?.condition}
                                        onChange={(e) => {
                                        const values = { ...formContent };
                                        const valuesRows = [...formContent?.dataRows];
                                        valuesRows[index].condition = e.target.value;
                                        values.dataRows = valuesRows;
                                        setFormContent(values);
                                        }}
                                        inline={{ width: "-webkit-fill-available" }}
                                    />
                                    ) : row?.condition ? (
                                    row?.condition
                                    ) : (
                                    "-"
                                    )}
                                </TableCell>
                                <TableCell>
                                    {isEdit ? (
                                    <Input
                                        id="disclamer"
                                        label="Disclamer..."
                                        type="text"
                                        style="full-border-field"
                                        value={row?.disclamer}
                                        onChange={(e) => {
                                        const values = { ...formContent };
                                        const valuesRows = [...formContent?.dataRows];
                                        valuesRows[index].disclamer = e.target.value;
                                        values.dataRows = valuesRows;
                                        setFormContent(values);
                                        }}
                                        inline={{ width: "-webkit-fill-available" }}
                                    />
                                    ) : row?.disclamer ? (
                                    row?.disclamer
                                    ) : (
                                    "-"
                                    )}
                                </TableCell>
                                {isEdit && (
                                    <TableCell>
                                    <img
                                        src={removeImg}
                                        height={18}
                                        width={18}
                                        className="cursor-pointer"
                                        onClick={() => handleRemoveDataRows(index)}
                                        style={{ opacity: 0.6 }}
                                        onMouseOver={(e) => e.target.style.opacity = 1}
                                        onMouseOut={(e) => e.target.style.opacity = 0.6}
                                    />
                                    </TableCell>
                                )}
                                </TableRow>
                            ))}
                            </>
                        ) : (
                            <TableRow className="text-center">
                            <TableCell colSpan={isEdit ? 5 : 4}>
                                {isLoading ? (
                                <Box
                                    sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    margin: "10px 0px",
                                    }}
                                >
                                    <CircularProgress size={25} />
                                </Box>
                                ) : (
                                <div className="d-flex justify-content-center">
                                    <p className="my-3 text-secondary">No Records to Show</p>
                                </div>
                                )}
                            </TableCell>
                            </TableRow>
                        )}
                        </TableBody>
                    </Table>
                </TableContainer>

                {isEdit && (
                    <div className="d-flex justify-content-end p-3">
                        <Button
                        variant="contained"
                         onClick={() => {
                            handleAddNewDataRows();
                        }}
                        disabled={isLoading}
                         sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600 }}
                        >
                        Add New Item
                        </Button>
                    </div>
                )}
             </PremiumCard>
            
            <SectionHeader title="Signatures" icon={<DescriptionIcon />} />
            <PremiumCard>
                <Row>
                     <Col sm={6} className="text-center">
                         <div
                            style={{ height: "90px" }}
                            className="d-flex justify-content-center align-items-end"
                        >
                             {formContent.clientSign != "" &&
                            formContent.clientSign != undefined && (
                                <img
                                src={`${Bucket}${formContent.clientSign}`}
                                height={80}
                                width={200}
                                 style={{maxHeight: '80px', maxWidth: '100%', objectFit: 'contain'}}
                                />
                            )}
                        </div>
                         <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                         <p className="my-1">
                            <b>{"Customer/Authorized"}</b>
                        </p>
                    </Col>
                     <Col sm={6} className="text-center">
                           <div
                            style={{ height: "90px" }}
                            className="d-flex justify-content-center align-items-end"
                        >
                            {formContent?.supervisorSign && (
                                <img
                                src={`${Bucket}${formContent?.supervisorSign}`}
                                height={80}
                                width={200}
                                 style={{maxHeight: '80px', maxWidth: '100%', objectFit: 'contain'}}
                                />
                            )}
                        </div>
                        <div style={{ borderTop: "1px solid #000", marginTop: "10px", width: "80%", margin: "10px auto" }}></div>
                        <p className="my-1">
                            <b>{"Supervisor"}</b>
                        </p>
                    </Col>
                </Row>
            </PremiumCard>

        </PremiumPublicLayout>
      ) : (
        <div className="no-print">
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </div>
      )}

      <PrintComponent>
        <ItemConditionDownload
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

       {/* Add signature Modal */}
       {isSignCanvas && (
          <MySignatureCanvas
            open={isSignCanvas}
            onClose={() => {
              setSignCanvas(false);
            }}
            onSuccess={(file) => {
              if (!isLoading) uploadFile(file);
            }}
          />
        )}
    </>
  );
};
export default ItemConditionReportClientSide;
